import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import { objArrayToMap } from 'app/admin/common/util/CommonUtil';
import PiWriterTaskEditDto from '../dto/PiWriterTaskEditDto';

class PiWriterTaskEditService {
    constructor() {
        this.connection = nBossConnection.connection;
        this.PARENT_CONTROL = 'taskManagerControl';
        this.CONTROL = 'piWriterTaskEditControl';
    }

    /**
     * @return {Promise<PiWriterTaskEditDto>}
     */
    create() {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then(response => resolve(new PiWriterTaskEditDto().setup(response.data)))
                .catch(reject);
        });
    }

    /**
     * @param {string} type
     * @return {Promise<PiWriterTaskEditDto>}
     */
    createByType(type) {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then(response => resolve(new PiWriterTaskEditDto().setup({ ...response.data, type })))
                .catch(reject);
        });
    }

    /**
     * @param {number} id
     * @return {Promise<PiWriterTaskEditDto>}
     */
    getData(id) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/getData`, {
                    id
                })
                .then(response => resolve(new PiWriterTaskEditDto().setup(response.data)))
                .catch(reject);
        });
    }

    /**
     * @param {PiWriterTaskEditDto} dto
     * @return {Promise<OcuEntityValidationResult>}
     */
    save(dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/save`, { dto: { ...dto } })
                .then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
                .catch(reject);
        });
    }

    /**
     * @param {number} id
     * @param {PiWriterTaskEditDto} dto
     * @return {Promise<OcuEntityValidationResult>}
     */
    update(id, dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/update`, {
                    id,
                    dto: { ...dto }
                })
                .then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
                .catch(reject);
        });
    }
}

export default new PiWriterTaskEditService();